import { HttpClient } from "./types";

export interface BudgetWhatsAppLine {
    productId: string;
    variantId: string;
    quantity: number;
    minimumQuantity?: number | null;
}

export interface CreateBudgetWhatsAppRequest {
    lines: BudgetWhatsAppLine[];
}

export interface CreateBudgetWhatsAppResponse {
    bigIdPresupuesto: number;
    uniIdPresupuesto: string;
    codigo: string;
}

export const createBudgetService = (httpClient: HttpClient) => ({
    createWhatsAppInquiry(
        request: CreateBudgetWhatsAppRequest,
    ): Promise<CreateBudgetWhatsAppResponse> {
        return httpClient.post<CreateBudgetWhatsAppResponse>("/presupuestos/consulta-whatsapp", {
            lstLineas: request.lines.map((line) => ({
                uniIdProducto: line.productId,
                uniIdProductoVariante: line.variantId,
                decCantidad: line.quantity,
                decCantidadMinima: line.minimumQuantity ?? 1,
            })),
        });
    },
});
